import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { shouldLoadStaffApp } from "@/publicRoutes";

// Two shells, downloaded on demand: parents get the small public bundle (landing / trial /
// public forms); staff get the full office app. The decision uses only the URL and whether a
// login token is stored, so nothing heavy is fetched before it is made.
const StaffApp = lazy(() => import("@/StaffApp"));
const PublicApp = lazy(() => import("@/PublicApp"));

// Storage can throw in locked-down webviews / "block all cookies" Safari; a parent must still get
// the public page, so treat an unreadable store as "no token".
let storedToken = null;
try {
  storedToken = localStorage.getItem("token");
} catch (e) {
  storedToken = null;
}

let Shell = shouldLoadStaffApp(window.location.pathname, storedToken) ? StaffApp : PublicApp;

// Local development only: /__student-demo previews the student app with sample data (no
// login, no API calls). NODE_ENV is a build-time constant, so production drops this branch.
if (process.env.NODE_ENV === "development" && window.location.pathname === "/__student-demo") {
  Shell = lazy(() => import("@/dev/StudentAppDemo"));
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <Shell />
    </Suspense>
  </React.StrictMode>,
);
